import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "privacypolicy" */ './views/PrivacyPolicyPage.vue'),
    },
    {
      path: '/privacy-policy/(index.html)?',
      name: 'privacypolicypage',
      component: () => import(/* webpackChunkName: "privacypolicy" */ './views/PrivacyPolicyPage.vue'),
    },
    {
      path: '/terms-of-service/(index.html)?',
      name: 'termsofservicepage',
      component: () => import(/* webpackChunkName: "termsofservice" */ './views/TermsOfServicePage.vue'),
      meta: {
        title: 'NetRoadshow - Terms of Service',
      },
    },
    {
      path: '/emailUnsubscribe/:id',
      name: 'emailUnsubscribe',
      beforeEnter(to, from, next) {
        document.title = 'NRS|RFN Unsubscribe';
        next();
      },
      component: () => import(/* webpackChunkName: "emailUnsubscribe" */ './views/EmailUnsubscribe.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
  });
  next();
});

export default router;
